module.exports = __webpack_public_path__ + "static/media/custom-keyboard-bg.903f28bb.svg";